import { MDXProvider } from "@mdx-js/react";
import * as stylex from "@stylexjs/stylex";
import { getThemeLabel } from "components/article-switcher";
import { getFocusMetadata } from "focus-content";
import useLocale from "hooks/useLocale";
import Link from "next/link";
import React from "react";
import { defineMessage, useIntl } from "react-intl";
import readingTime from "reading-time";
import { findArticleThemeAlias, useAlias } from "routes";
import * as M from "../../materials";
import { colors, layoutAreas } from "../../materials/consts.stylex";
import { baseElements } from "../../materials/typography/markdown";
import { typography } from "../../materials/typography.stylex";
const styles = {
    header: {
        k1xSpc: "x78zum5",
        kGNEyG: "x6s0dn4",
        kwnvtZ: "x1a02dak",
        khm7nJ: "x3pnbk8",
        kAzted: "x21xpn4",
        kjj79g: "x1qughib",
        kMwMTN: "x196nufh",
        $$css: true
    },
    title: {
        kMwMTN: "x1a2e7zb",
        kmVPX3: "x1vrndsf",
        $$css: true
    }
};
export function FocusDetails({ url, children }) {
    const intl = useIntl();
    const focusRef = React.useRef(null);
    const [readingStats, setReadingStats] = React.useState();
    const alias = useAlias();
    const locale = useLocale();
    const { year, article } = getFocusMetadata(alias === "home" ? "1-demand" : alias, locale);
    const theme = findArticleThemeAlias(article);
    React.useEffect(()=>{
        const text = focusRef.current?.textContent;
        if (text) {
            setReadingStats(readingTime(text));
        }
    }, []);
    if (!theme) {
        return null;
    }
    return <div id="focus-post" className="x1uq3dmu" ref={focusRef}>
      <div {...stylex.props(typography.table, styles.header)}>
        <div className="x78zum5 x6s0dn4 x167g77z">
          <div className="x117nqv4">
            {" "}
            {`${year} ${intl.formatMessage(defineMessage({
        id: "GEM Report",
        defaultMessage: "GEM Report"
    }))}`}{" "}
          </div>
          <div className="xuoj239 x1g8rjiy xf995h5 xorixrz"/>
          {readingStats && <>
              <div>{`${Math.ceil(readingStats.minutes)} ${intl.formatMessage(defineMessage({
        id: "min read",
        defaultMessage: "min read"
    }))}`}</div>
              <div className="xuoj239 x1g8rjiy xf995h5 xorixrz"/>
            </>}
          <a href={url} target="_blank" rel="noopener noreferrer" className="x117nqv4 x1g71jbt">
            {intl.formatMessage(defineMessage({
        id: "View in report",
        defaultMessage: "View in report"
    }))}
          </a>
        </div>
        <div className="x78zum5 x6s0dn4 x167g77z">
          {intl.formatMessage(defineMessage({
        id: "Published in",
        defaultMessage: "Published in"
    }))}
          <Link href={`/articles/${theme}`}>
            <mark className="x78zum5 x17y4j5z xgqmno8 x1vc0dw xxk0z11 xl56j7k x1xq1gxn x15mdinu x6s0dn4 xuxw1ft x15b6vj9 x1klbbdq" style={{
        "--focus-badge-bg": M.themes[theme].palette[7]
    }}>
              {getThemeLabel(theme)}
            </mark>
          </Link>
        </div>
      </div>
      <hr className="xhv1u6h xc342km x178xt8z x13fuv20 xw192ze"/>
      <div className={`focus-details-content ${({
        className: "x1ib1h6n"
    }).className}`}>
        <MDXProvider components={baseElements}>{children}</MDXProvider>
      </div>
    </div>;
}
export const FocusTitle = ({ children })=>{
    return <h1 {...stylex.props(typography.title, styles.title)}>{children}</h1>;
};
